<script setup lang="ts">
import { watch, onBeforeMount } from 'vue';
import { createError } from '#app/composables/error';
import { useSeoMeta, useHead } from '#app/composables/head';
import { useRuntimeConfig } from '#app/nuxt';
import { useRoute } from '#app/composables/router';
import { SEO_KEYWORDS } from '~/constants/seo';
import { useOgImage } from '~/composables/useOgImage';
import { useScreenSize } from '~/composables/useScreenSize';
import { useGooglePublisherTag } from '~/composables/useGooglePublisherTag';

const route = useRoute();
const config = useRuntimeConfig();
const { APP_ENV } = config.public;

const { initialize, refresh } = useGooglePublisherTag();
const { screenSize } = useScreenSize();

useHead({
  htmlAttrs: {
    lang: 'ja',
  },
  templateParams: {
    siteName: 'ダイエットプラス',
    separator: '|',
  },
  titleTemplate: '%s %separator %siteName',
  meta: [
    {
      property: 'SKYPE_TOOLBAR',
      content: 'SKYPE_TOOLBAR_PARSER_COMPATIBLE',
    },
    {
      name: 'keywords',
      content: SEO_KEYWORDS,
    },
  ],
  link: [
    {
      rel: 'shortcut icon',
      sizes: '32x32',
      href: '/favicon.ico',
      type: 'image/vnd.microsoft.icon',
    },
    {
      rel: 'icon',
      sizes: '32x32',
      href: '/favicon.ico',
      type: 'image/vnd.microsoft.icon',
    },
    { rel: 'apple-touch-icon', href: '/apple-touch-icon.png' },
    {
      rel: 'apple-touch-icon',
      sizes: '152x152',
      href: '/apple-touch-icon-152.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/apple-touch-icon-180.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '167x167',
      href: '/apple-touch-icon-167.png',
    },
  ],
});

const { ogImage } = useOgImage();

useSeoMeta({
  ogUrl: `${config.public.siteUrl}${route.path}`,
  ogType: 'article',
  ogImage,
  ogSiteName: 'ダイエットプラス',
  author: 'ダイエットプラス',
  formatDetection: 'telephone=no',
});

// NOTE: Rollbarの通知テスト用
if (APP_ENV !== 'production' && route.query['rollbar-test-vue'] !== undefined) {
  throw createError({
    message: 'Rollbar通知テスト（vue:error）',
    cause: {
      foo: 'bar',
    },
  });
}

onBeforeMount(() => {
  initialize();
});

watch(screenSize, (_, oldVal) => {
  if (oldVal) {
    refresh();
  }
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
@font-face {
  font-family: DietplusRunes;
  src: url('@/assets/fonts/DietplusRunes.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}
</style>
